import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Login.css';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const [logoUrl, setLogoUrl]   = useState(null);
  const { login } = useAuth();
  const navigate  = useNavigate();

  useEffect(() => {
    fetch('/api/receipt/pin-logo/preview')
      .then(res => { if (!res.ok) throw new Error(); return res.blob(); })
      .then(blob => {
        const reader = new FileReader();
        reader.onload = () => setLogoUrl(reader.result);
        reader.readAsDataURL(blob);
      })
      .catch(() => {});
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username, password);
      navigate('/');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="login-logo">
          {logoUrl ? (
            <img src={logoUrl} alt="Logo" style={{ maxHeight: 80, maxWidth: 200, objectFit: 'contain', marginBottom: 4 }} />
          ) : (
            <span className="login-icon">☕</span>
          )}
          <h1>CafePOS</h1>
          <p>Panel kelnera</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="field">
            <label>Użytkownik</label>
            <input
              type="text"
              value={username}
              onChange={e => setUsername(e.target.value)}
              placeholder="Nazwa użytkownika"
              autoFocus
              required
            />
          </div>
          <div className="field">
            <label>Hasło</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>
          {error && <div className="login-error">{error}</div>}
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Logowanie...' : 'Zaloguj się'}
          </button>
        </form>
      </div>
    </div>
  );
}
